import { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { useWindowWide } from '../../helpers/wideScreen';
import { SETTINGS_LAYOUT } from '../../routes/routes';
import { SectionSeparatorVertical } from '../../styles/GlobalComponents';
import { SettingsNavigation } from './Navigation';
import { ContentWrapper, SettingsWrapper } from './SettingsStyled';
import { settingsInit } from './Settings.actions';

export const Settings = ({ children }: { children: ReactNode }) => {
  const wide = useWindowWide(800);
  const location = useLocation();
  const dispatch = useDispatch();

  const { loadingInit, user } = useAppSelector((state) => state.settings);

  useEffect(() => {
    dispatch(settingsInit());
  }, [dispatch]);

  if (loadingInit && !user) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom dark>
      <SettingsWrapper>
        {!wide && location.pathname === SETTINGS_LAYOUT && (
          <SettingsNavigation />
        )}
        {wide && <SettingsNavigation />}
        {wide && <SectionSeparatorVertical margin='0 10px' />}
        {location.pathname !== SETTINGS_LAYOUT && (
          <ContentWrapper>{children}</ContentWrapper>
        )}
      </SettingsWrapper>
    </AnimatedDashboard>
  );
};
